import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '@getro/rombo';
import { Flex, Text } from 'rebass/styled-components';

const DisconnectGoogleAccount = ({ isSubmitting, onCancel, onConfirm }) => (
  <Modal
    title="Disconnect Google account?"
    isOpen
    onCancel={onCancel}
    actions={
      <Flex justifyContent={['flex-end']}>
        <Button onClick={onCancel} variant="tertiary">
          Cancel
        </Button>
        <Button variant="danger" loading={isSubmitting} onClick={onConfirm}>
          Disconnect
        </Button>
      </Flex>
    }
  >
    <Text width={1} mb={2} fontSize="14px">
      Disconnecting this account will:
    </Text>
    <ul
      style={{
        paddingLeft: '16px',
        marginTop: 0,
        marginBottom: 0,
        fontSize: '14px',
        lineHeight: '1.4',
      }}
    >
      <li style={{ marginBottom: '8px' }}>Stop syncing contacts</li>
      <li>
        Remove all contacts from the networks they&apos;re being shared with (unless they&apos;ve been added in other
        ways)
      </li>
    </ul>
  </Modal>
);

DisconnectGoogleAccount.propTypes = {
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

DisconnectGoogleAccount.defaultProps = {
  isSubmitting: false,
};

export default DisconnectGoogleAccount;
